import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { ITargetRange } from "../ITargetRange";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";
import { VitalSignExam } from "./VitalSignExam";

class VitalSignCareElement extends BaseCareElement {
    public CareElementType: CareElementType.VitalSigns;

    public Name: string;
    public Frequency?: CareElementFrequencyType;
    public TargetRange?: ITargetRange;
    public Operator?: CareElementOperatorType;
    public Unit?: string;
    public Exams: VitalSignExam[];

    public constructor(init?: NonFunctionProperties<VitalSignCareElement>) {
        super();
        Object.assign(this, init);
    }
}

export { VitalSignCareElement };
